import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/common";
function FileUploadComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4)(1, "div", 5);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 6);
    i0.ɵɵelement(3, "circle", 7);
    i0.ɵɵelementEnd()()();
} }
export class FileUploadComponent {
    constructor(http) {
        this.http = http;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.success = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.error = new EventEmitter();
        this.isSaving = false;
    }
    uploadFile(event) {
        const { target } = event;
        const files = target.files;
        if (files !== null) {
            const formData = new FormData();
            formData.append('file', files[0]);
            const url = this.uploadUrl;
            const name = files[0].name;
            const body = formData;
            this.isSaving = true;
            this.http.post(url, body).subscribe((response) => {
                this.onSuccess({ content: name, url: response.url });
            }, (response) => {
                if (response.status === 409) {
                    this.onSuccess({ content: name, url: response.error.url });
                }
                else {
                    this.isSaving = false;
                    this.error.emit();
                }
            });
        }
    }
    onSuccess(data) {
        this.isSaving = false;
        this.success.emit({ content: data.content, url: data.url });
    }
}
FileUploadComponent.ɵfac = function FileUploadComponent_Factory(t) { return new (t || FileUploadComponent)(i0.ɵɵdirectiveInject(i1.HttpClient)); };
FileUploadComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FileUploadComponent, selectors: [["mhe-file-upload"]], inputs: { formats: "formats", uploadUrl: "uploadUrl", customMessage: "customMessage" }, outputs: { success: "success", error: "error" }, decls: 5, vars: 3, consts: [[1, "file-input-wrapper"], ["type", "file", 1, "input-file", 3, "accept", "change"], ["class", "ahe-ui-loading-spinner overlay", 4, "ngIf"], [1, "custom-message"], [1, "ahe-ui-loading-spinner", "overlay"], [1, "loader", "spinner"], ["viewBox", "25 25 50 50", 1, "circular"], ["cx", "50", "cy", "50", "r", "10", "fill", "none", "stroke-width", "2", "stroke-miterlimit", "10", 1, "path"]], template: function FileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        i0.ɵɵlistener("change", function FileUploadComponent_Template_input_change_1_listener($event) { return ctx.uploadFile($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, FileUploadComponent_span_2_Template, 4, 0, "span", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("accept", ctx.formats);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSaving);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.customMessage);
    } }, dependencies: [i2.NgIf], styles: [".input-file[_ngcontent-%COMP%]{display:inline}.file-input-wrapper[_ngcontent-%COMP%]{position:relative}.custom-message[_ngcontent-%COMP%]{font-size:14px;margin-top:5px}.format_types[_ngcontent-%COMP%]{text-transform:uppercase}.ahe-ui-loading-spinner.overlay[_ngcontent-%COMP%]{background:rgba(0,0,0,0);position:absolute;right:auto;left:auto}.ahe-ui-loading-spinner.overlay[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{width:35px;margin:0;float:right;top:10px}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadComponent, [{
        type: Component,
        args: [{ selector: 'mhe-file-upload', template: "<div class=\"file-input-wrapper\">\n  <input type=\"file\" class=\"input-file\" [accept]=\"formats\" (change)=\"uploadFile($event)\" />\n\n  <span *ngIf=\"isSaving\" class=\"ahe-ui-loading-spinner overlay\">\n    <div class=\"loader spinner\">\n      <svg class=\"circular\" viewBox=\"25 25 50 50\">\n        <circle\n          class=\"path\"\n          cx=\"50\"\n          cy=\"50\"\n          r=\"10\"\n          fill=\"none\"\n          stroke-width=\"2\"\n          stroke-miterlimit=\"10\"\n        ></circle>\n      </svg>\n    </div>\n  </span>\n\n  <div class=\"custom-message\">{{ customMessage }}</div>\n</div>\n", styles: [".input-file{display:inline}.file-input-wrapper{position:relative}.custom-message{font-size:14px;margin-top:5px}.format_types{text-transform:uppercase}.ahe-ui-loading-spinner.overlay{background:rgba(0,0,0,0);position:absolute;right:auto;left:auto}.ahe-ui-loading-spinner.overlay .spinner{width:35px;margin:0;float:right;top:10px}/*# sourceMappingURL=file-upload.component.css.map */\n"] }]
    }], function () { return [{ type: i1.HttpClient }]; }, { formats: [{
            type: Input
        }], uploadUrl: [{
            type: Input
        }], customMessage: [{
            type: Input
        }], success: [{
            type: Output
        }], error: [{
            type: Output
        }] }); })();
